import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import * as types from 'constants/actionTypes';
import { ReaderToolType } from 'constants/ReaderTools';
import { gaEventReaderToolsClick } from 'components/AppService/GAService';
import { CategoryType } from 'constants/gaEventType';

export const useTimerCommand = () => {
    const [_, globalDispatch] = useStore(StoreTypes.global);

    const execute = useCallback(async () => {
        try {
          gaEventReaderToolsClick({
            category: CategoryType.ReaderTool,
            action: ReaderToolType.Timer,
            label: ReaderToolType.Timer
          });
          globalDispatch({ type: types.OPEN_TIMER_MODAL })
          EventBus.emit({
            event: ReaderToolsEvent.ClickReaderToolBoxEvent,
            payload: {
              isToolboxShow: false
            }
          })
        } catch (e) {
            console.error('TimerCommand execute error', e);
        }
    }, [globalDispatch]);

    return { execute };
};
